<template>
  <div>

    <IndxHead></IndxHead>
    <section class="aboutbg" style="display: grid; align-items:end ;">
      <div class="bgBlue color-fff">
        <div class="w1024">
          <h1 style="color: #ffffff; font-size: 50px; ">厚德·融合·成长</h1>
          <p style="color: rgb(227 227 227 / 95%);font-size: 20px;">诚信立业 创新发展</p>
        </div>
      </div>
    </section>
    <section class="aboutCt">
      <div>
        <!-- <img :src="logBg" alt="" class="logBg"> -->
        <div class="w1024">
          <div class="text-left">
            <h1 class="pt-100 color-2" style="font-size: 30px;">关于我们</h1>
            <p class="text-uppercase " style="font-size: 16px; color: #cccccc;">about us</p>
          </div>
          <div class="aboutBox">

             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京道信资产管理有限公司于2016年3月成立，总部位于北京市海淀区中关村高新技术核心区，具有得天独厚的区位优势，能够快速捕捉前沿信息与创新资源。 <br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司始终秉持“厚德、融合、成长”的投资理念，注重跨行业资源整合，助力企业健康快速成长，覆盖教育、科技、现代农业、矿业、环保、新能源、新材料、建设工程、文旅、大健康等多个极具发展潜力的投资领域。 <br>
     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;凭借专业的投资团队和精准的市场洞察力，公司已成功投运项目50多个。目前，在投运营管理规模超过30亿元，展现出强劲的实力与卓越的运营管理能力，在行业中树立了良好的口碑与典范。
             
          </div>
          <div class="d-flex space-between pt-100">
            <div>
              <div><img :src="comP1" alt=""></div>
              <div style="font-size: 50px;color: #0b3379; ">

                <count-to ref="count1" :start-val="2000" :end-val="2016" separator="" :duration="3000" :autoplay="false"
                  class="  fs-60" />
                年
              </div>
              <div style="color: #0b3379;">成立时间</div>
            </div>
            <div>
              <div><img :src="comP2" alt=""></div>
              <div style="font-size: 50px;color: #0b3379; "><count-to ref="count2" :start-val="0" :end-val="50"
                  :duration="1200" :autoplay="false" class=" fs-60" />个</div>
              <div style="color: #0b3379;">投资项目</div>
            </div>
            <div>
              <div><img :src="comP3" alt=""></div>
              <div style="font-size: 50px;color: #0b3379; "><count-to ref="count3" :start-val="0" :end-val="30"
                  :duration="1200" :autoplay="false" class="  fs-60" />亿</div>
              <div style="color: #0b3379;">运营规模</div>
            </div>
          </div>
        </div>
      </div>

    </section>
    <!--  -->


    <section class="tenIc">

      <div class="w1024">
        <div class="text-left">
          <h1 class="pt-100 color-fff" style="font-size: 30px;">业务范围</h1>
          <p class="text-uppercase " style="font-size: 16px; color: #ffffff;">scope of business </p>
        </div>

        <div>

          <table class="table_tr">
            <tr>
              <td>
                <div>
                  <img :src="expl1" />
                  <p>教育</p>
                </div>

              </td>
              <td>
                <div>
                  <img :src="expl2" />
                  <p>环保</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl3" />
                  <p>科技</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl4" />
                  <p>现代农业</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl5" />
                  <p>矿业</p>
                </div>
              </td>

            </tr>
            <tr>
              <td>
                <div>
                  <img :src="expl6" />
                  <p>新能源</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl7" />
                  <p>新材料</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl8" />
                  <p>建设工程</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl9" />
                  <p>文旅</p>
                </div>
              </td>
              <td>
                <div>
                  <img :src="expl10" />
                  <p>大健康</p>
                </div>
              </td>

            </tr>
          </table>
        </div>
      </div>

    </section>
    <section  id="investor-relations" class="relationSp">
      <div class="w1024">


        <div class="w1024">

          <div class="text-left">
            <h1 class="pt-100 color-2" style="font-size: 30px;">投资者关系</h1>
            <p class="text-uppercase " style="font-size: 16px; color: #cccccc;">Investor Relations</p>
          </div>
          <div>

            <ul class="relations">
              <li v-for="(value, index) in source" :key="index" class="d-flex space-between fs-14" @click="opens(value.url)"><span style="   overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 70%; /* 根据需要调整 */">{{ value.titele
  }}</span> <span>{{ value.date }}</span>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </section>

    <!--  -->

    <IndxFoot></IndxFoot>

  </div>
</template>

<script>
import logBg from '@/images/bgft1.png'
import expl1 from '@/images/f2221.png'
import expl2 from '@/images/f5.png'
import expl3 from '@/images/f10.png'
import expl4 from '@/images/f6.png'
import expl5 from '@/images/f4.png'
import expl6 from '@/images/f8.png'
import expl7 from '@/images/f9.png'
import expl8 from '@/images/f3js.png'
import expl9 from '@/images/f1.png'
import expl10 from '@/images/f7.png'
import comP1 from '@/images/ab4.png'
import comP2 from '@/images/ab3.png'
import comP3 from '@/images/ab2.png'
import IndxHead from '@/components/IndxHead.vue'
import IndxFoot from '@/components/IndxFoot.vue'
import CountTo from 'vue-count-to'
export default {
  name: 'HomePage',
  components: {
    IndxHead,
    IndxFoot, CountTo,
  },
  data() {
    return {
      source: [{
        titele: "新矿产资源法的十大亮点", date: '02-08',text:'矿产资源是工业的粮食和血液，是经济社会发展的重要物质基础。随着工业化、城镇化的快速推进，我国对矿产资源的需求和消耗日益增大。同时，随着绿色低碳革命在全球的推进', url:'https://www.gov.cn/lianbo/bumen/202411/content_6986009.htm'
      },
      { titele: '新修订的《中华人民共和国矿产资源法》 ', text:'(1986年3月19日第六届全国人民代表大会常务委员会第十五次会议通过  根据1996年8月29日第八届全国人民代表大会常务委员会第二十一次会议《关于修改〈中华人民共和国矿产资源法〉的决定》',date: '05-09' ,url:'http://www.gsht.gov.cn/zfxxgk/bmxzxxgk/xzxxgk/htssyxrmzf/fdzdgknr/YJGL/art/2025/art_a0971c70db614319b7f3c5b00e68c2d2.html'},
      { titele: '新能源2035年目标：风光装机容量迈向36亿千瓦 ', text:'截至2024年底，全国风电、光伏装机容量已达13.5亿千瓦，提前6年完成《巴黎协定》设定的2030年目标。而2035年36亿千瓦的装机容量，相当于在现有基础上再造两个半“中国电网”，其规模超过美国、欧盟、印度三大经济体总和。',date: '06-29',url:'https://xueqiu.com/1438272693/354635779' },
      { titele: '“十五五”规划（2026-2030年）核心内容解析 ',text:'“十五五”规划是我国迈向2035年基本实现社会主义现代化目标的关键五年规划，其核心内容围绕“高质量发展”主线，聚焦“科技自立自强”“产业升级”“内需扩大”“安全保障”四大维度，旨在通过系统性部署破解发展难题、增强发展动力、厚植发展优势。',date: '06-19',url:"http://www.360doc6.net/wxarticlenew/1163849574.html"},
      { titele: 'A股三大股指尾盘下跌，摩尔线程猛涨28%市值破4400亿，加密货币全线杀跌15万人爆仓', text:'12月11日午后，亚太股市呈现“先扬后抑”的剧烈反转，截至收盘日韩股市集体收跌，A股三大股指尾盘也加速下跌，创业板指、深证成指均跌超1%，沪指跌0.7%，全市场超4300只个股下跌。泛消费、房地产、纺织服装、食品饮料等方向跌幅居前。', date: '07-26',url:'https://www.21jingji.com/article/20251211/herald/29973b6d31bfbc3b90ecec1bd09f43de.html' },
      { titele: '兴业证券：氢能市场前景和生态价值广阔 推荐绿色甲醇生产环节   ', text:'兴业证券发布研报称，氢能在十五五期间走向规模化的规划更加清晰。同时展现出广阔的市场前景和生态价值，但是具备经济性、可持续性的商业模式仍是',date: '08-22',url:"https://finance.sina.com.cn/stock/hkstock/ggscyd/2025-12-05/doc-infzttzy9885006.shtml" },
      { titele: 'OpenAI会是第一个倒闭的AI独角兽吗？ ',text:'11月20日，Gemini3推出两天后，在被称为“硅谷投资人春晚”的Cerebral Valley AI峰会上，OpenAI就被选成了“第二大可能倒闭的AI独角兽”。', date: '08-25',url:"https://finance.sina.com.cn/tech/internet/2025-12-07/doc-infzxvsr3004349.shtml" },
      { titele: '好生意的故事，给投资带来的启发：', text:'一位茶商，祖上就经营云南的古树生普，他家的恒温存茶的库房，一进去，满屋茶砖茶饼，茶香四溢。现在库房里还存有上世纪60年代的普洱茶，而这些普洱茶当年的收购价1斤竟然不到1元钱',date: '09-28',url:'https://xueqiu.com/1176935028/360177531' },
      ],
      currentSlide: 0,
      totalSlides: 3,
      autoPlayInterval: null,
      comP1: comP1,
      comP2: comP2,
      comP3: comP3,
      expl1: expl1,
      expl2: expl2,
      expl3: expl3,
      expl4: expl4,
      expl5: expl5,
      expl6: expl6,
      expl7: expl7,
      expl8: expl8,
      expl9: expl9,
      expl10: expl10,
      logBg: logBg
    }
  },
  mounted() {
    this.setupAboutSectionObserver();
     this.scrollToInvestorRelations();
  },
  beforeUnmount() {
  // 清理观察器
    if (this.aboutObserver) {
      this.aboutObserver.disconnect();
    }
  },
  methods: {
    opens(items) {
      window.open(items, '_blanks')
    },
      // 滚动到投资者关系部分
    scrollToInvestorRelations() {
      this.$nextTick(() => {
        const section = this.$route.query.section;
        if (section === 'investor-relations') {
          setTimeout(() => {
            const element = document.getElementById('investor-relations');
            if (element) {
              const headerHeight = 80;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
              
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
            }
          }, 300);
        }
      });
    },
    setupAboutSectionObserver() {
      // 创建Intersection Observer
      this.aboutObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          // 当关于部分进入视口时
          if (entry.isIntersecting) {
            // 触发计数动画
            this.startCountAnimations();
          }
        });
      }, {
        threshold: 0.3 // 当30%的元素可见时触发
      });

      // 观察关于部分
      const aboutSection = this.$el.querySelector('.aboutCt');
      if (aboutSection) {
        this.aboutObserver.observe(aboutSection);
      }
    },
    startCountAnimations() {
      // 确保组件已挂载
      this.$nextTick(() => {
        // 重置并启动每个计数动画
        if (this.$refs.count1) {
          this.$refs.count1.start();
        }
        if (this.$refs.count2) {
          this.$refs.count2.start();
        }
        if (this.$refs.count3) {
          this.$refs.count3.start();
        }
      });
    },









  },
 watch: {
    // 监听路由参数变化
    '$route.query.section': {
      handler(newVal) {
        if (newVal === 'investor-relations') {
          this.scrollToInvestorRelations();
        }
      },
      immediate: false
    }
  }




}
</script>

<style scoped>
/* 为投资者关系部分添加滚动边距 */
#investor-relations {
  scroll-margin-top: 80px;
}
.logBg {
  position: absolute;
  left: 0;
  top: 0px;


}

.bgBlue {
  background: url(/src/images/ab112.png) bottom no-repeat;
  background-size: cover;
  width: 100%;
  height: 300px;

}

.bgBlue .w1024 {
  text-align: right;
  position: relative;
  top: -100px;
}

.aboutbg {
  background: url(/src/images/ab1.png) no-repeat;
  background-size: cover;
  height: 800px;
}

.tenIc {
  background: url(/src/images/ab22.png) no-repeat;
  background-size: cover;
  height: 900px;
}

.relationSp {
  background: url(/src/images/ab11.png) no-repeat;
  background-size: cover;
  height: 780px;
}

.aboutCt {
  position: relative;
  background: url(/src/images/ab33.png) no-repeat;
  background-size: cover;
  height: 800px;
}

.table_tr {
  margin-top: 90px;
  width: 100%;
  height: 440px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-collapse: collapse;
  /* 关键属性 */
}

.table_tr tr td {
  border: 1px solid rgba(255, 255, 255, 0.4);
  width: calc(20%);
  color: #ffffff;
  font-size: 16px;
}

.table_tr tr td {
  transition: transform 0.3s ease;
}

.table_tr tr td img {
  margin-bottom: 10px;
  width: 40px;

}

.table_tr tr td:hover {
  cursor: pointer;
  transform: translateY(-5px);
}

.relations li:hover {
  color: #000;
  cursor: pointer;
}

.relations {
  line-height: 3;
  padding-top: 60px;
}

.aboutBox {
  width: 580px;
  text-align: left;
  font-size: 14px;
  line-height: 2;
  padding-top: 30px;
  letter-spacing: 2px;
  color: #000;
}
</style>